module.exports = __webpack_public_path__ + "static/media/male-yellow-v3@2x.92f55204.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/male-yellow-v3@2x.png
// module id = 74
// module chunks = 0